import React from 'react'

const BoldPlusIcon = () => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="10" y="3" width="4" height="18" rx="1" />
            <rect x="3" y="10" width="18" height="4" rx="1" />
        </svg>
    )
}

export default BoldPlusIcon
